import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGift01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.67 5a3.032 3.032 0 0 1 .692-3.115A2.947 2.947 0 0 1 8.464 1C10.26 1 11.373 2.218 12 3.272 12.627 2.218 13.741 1 15.536 1c.792 0 1.548.32 2.102.885A3.018 3.018 0 0 1 18.33 5h2.197c.21 0 .414 0 .588.012.19.013.416.043.65.14a2 2 0 0 1 1.083 1.083c.097.234.127.46.14.65.012.174.012.378.012.588v.054c0 .21 0 .414-.012.588a2.03 2.03 0 0 1-.14.65 2 2 0 0 1-1.083 1.083 2.03 2.03 0 0 1-.65.14c-.174.012-.378.012-.588.012H3.473c-.21 0-.415 0-.59-.012a2.029 2.029 0 0 1-.65-.14 2 2 0 0 1-1.082-1.083 2.029 2.029 0 0 1-.14-.65C1 7.941 1 7.737 1 7.527v-.054c0-.21 0-.414.012-.588.013-.19.043-.416.14-.65a2 2 0 0 1 1.083-1.083c.234-.097.46-.127.65-.14A9.15 9.15 0 0 1 3.474 5H5.67Zm2.794-2c-.25 0-.493.1-.675.286A1.019 1.019 0 0 0 7.5 4c0 .271.106.527.289.714A.947.947 0 0 0 8.464 5h2.17a6.117 6.117 0 0 0-.25-.525C9.898 3.575 9.274 3 8.464 3Zm4.902 2c.072-.171.155-.349.25-.525.486-.9 1.11-1.475 1.92-1.475.25 0 .493.1.675.286.183.187.289.443.289.714 0 .271-.106.527-.289.714a.947.947 0 0 1-.675.286h-2.17Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3 13a1 1 0 0 1 1-1h6.2c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v9.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C10.62 23 10.48 23 10.2 23H7.161c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C3 19.82 3 19.365 3 18.838V13ZM18.195 22.97c-.375.03-.83.03-1.357.03H13.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C13 22.62 13 22.48 13 22.2v-9.4c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C13.38 12 13.52 12 13.8 12H20a1 1 0 0 1 1 1v5.839c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296Z"
    />
  </svg>
);
SvgGift01.displayName = 'Gift01';
export default SvgGift01;
